module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-end-24c263db.svg";